/** @jsx jsx */
import { jsx } from '@compiled/react';
import Avatar from '@atlaskit/avatar';

import WithProfileCard from '@atlassian/jira-issue-view-internal-profilecard-next/src/index.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';
import AkCommentAvatarWrapper from './AkCommentAvatarWrapper.tsx';

const AkCommentAvatar = () => {
	const { isThreadedCommentsEnabled, isDeleted, author, commentId, showSmallAvatar, parentId } =
		useCommentContext();
	return (
		<AkCommentAvatarWrapper>
			<WithProfileCard
				userAccount={isDeleted ? undefined : author}
				analyticsData={{ trigger: 'comment-avatar' }}
				testId={`issue-comment-base.ui.comment.${commentId}.avatar`}
				ariaHideProfileTrigger
				isChildComment={isThreadedCommentsEnabled && !!parentId}
			>
				<Avatar
					borderColor="transparent"
					src={(!isDeleted && author && author.avatarUrl) || undefined}
					size={showSmallAvatar ? 'small' : 'medium'}
				/>
			</WithProfileCard>
		</AkCommentAvatarWrapper>
	);
};
export default AkCommentAvatar;
